import classNames from 'classnames'
import { NavigationInterface } from 'client/Interfaces/NavigationInterface'
import { l } from 'client/Other/Translation'
import React from 'react'

import './styles.scss'

interface WelcomeModalProps {
  isLoading: boolean
  isShow: boolean
  navigation?: NavigationInterface
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isLoading, isShow }) => {
  const [show, setShow] = React.useState(isShow)
  const firstSessionLoadingMainTxt = window.localStorage.firstSessionLoadingMainTxt || l('firstSessionLoadingMainTxt')
  const firstSessionLoadedMainTxt = window.localStorage.firstSessionLoadedMainTxt || l('firstSessionLoadedMainTxt')
  const firstSessionLoadingSubTxt = window.localStorage.firstSessionLoadingMainTxt || l('firstSessionLoadingSubTxt')
  const firstSessionLoadedSubTxt = window.localStorage.firstSessionLoadedSubTxt || l('firstSessionLoadedSubTxt')

  const removeWelcomeModal = () => {
    window.localStorage.removeItem('WelcomeModal')
    setShow(false)
  }

  if (!show) {
    return <></>
  }

  return (
    <div className={classNames('welcome-modal', { 'welcome-modal--transparent': !isLoading })}>
      <div className="welcome-modal__wrap">
        <div className="welcome-modal__image"></div>
        <span className="welcome-modal__header loading-state-text">
          {isLoading ? firstSessionLoadingMainTxt : firstSessionLoadedMainTxt}
        </span>
        <span className="welcome-modal__subtext loading-state-text">
          {isLoading ? firstSessionLoadingSubTxt : firstSessionLoadedSubTxt}
        </span>
        {isLoading && <div className="welcome-modal__css-loader"></div>}
        {!isLoading && (
          <div
            className="welcome-modal__start-invoicing"
            onClick={() => {
              removeWelcomeModal()
            }}
          >
            {l('startInvoicing')}
          </div>
        )}
      </div>
    </div>
  )
}

export default WelcomeModal
